import { useDeviceType } from '@cian/ui-kit';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { MARTECH_BANNER_STONE_EXPERIMENT } from '../../../constants/config';
import { STONE_BANNER } from '../../../constants/stone';
import { isExperimentActive, selectExperiments } from '../../../selectors/experiments';
import { selectMapBounds } from '../../../selectors/mapBounds';
import { selectParentRegionId } from '../../../selectors/parentRegionId';
import { selectJsonQuery } from '../../../selectors/results';
import { TAdfoxMapBannerConfig, TAdfoxMapBannerConfigItem } from '../../../types/adfoxMapBannerConfig';
import { IApplicationState } from '../../../types/redux';
import { getAdfoxBannerConfig } from '../../../utils/bannerPackages';
import { useApplicationContext } from '../../ApplicationContext';

export function useSelectedAdfoxBannerConfig(): TAdfoxMapBannerConfigItem | null {
  const deviceType = useDeviceType();
  const jsonQuery = useSelector(selectJsonQuery);
  const { zoom } = useSelector(selectMapBounds);
  const adfoxMapBannerConfig = useSelector((state: IApplicationState) => state.config.adfoxMapBannerConfig);
  const experiments = useSelector(selectExperiments);
  const parentRegionId = useSelector(selectParentRegionId);
  const { config } = useApplicationContext();

  const adfoxEnabled = config.get<boolean>('mapSearchFrontend.AdfoxMapBanner.Enabled') || false;

  const filteredConfig = useMemo<TAdfoxMapBannerConfig>(() => {
    const isStoneExperimentActive = isExperimentActive(experiments, MARTECH_BANNER_STONE_EXPERIMENT, 'B');

    return adfoxMapBannerConfig.filter(item => {
      if (item.developerId === STONE_BANNER.developerId) {
        return isStoneExperimentActive;
      }

      return true;
    });
  }, [adfoxMapBannerConfig, experiments]);

  return getAdfoxBannerConfig({
    zoom,
    jsonQuery,
    deviceType,
    adfoxEnabled,
    adfoxMapBannerConfig: filteredConfig,
    parentRegionId,
  });
}
